import { Box, VStack, useToken } from '@chakra-ui/react'

import { Icon } from '../Icons/Icon'

interface NotificationIconProps {
  count?: number
}

export const NotificationIcon = ({ count = 0 }: NotificationIconProps) => {
  const white = useToken('colors.presets', 'neutral.0')
  const black = useToken('colors.presets', 'neutral.100')

  return (
    <VStack alignItems="center" justifyContent="center" position="relative">
      <Icon
        icon="BellIcon"
        boxSize="20px"
        _light={{ color: black }}
        _dark={{
          color: white,
        }}
      />
      {!!count && <IconBadge count={count} />}
    </VStack>
  )
}

interface IconBadgeProps {
  count?: number
}

export const IconBadge = ({ count = 0 }: IconBadgeProps) => (
  <Box
    position="absolute"
    top="-5px"
    right="-5px"
    height="14px"
    width="14px"
    fontWeight="400"
    rounded="full"
    fontSize="11px"
    lineHeight="14px"
    verticalAlign="middle"
    textAlign="center"
    background="presets.pink.70"
    color="presets.neutral.0"
  >
    {count > 10 ? '9+' : count}
  </Box>
)
